import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class CompactDayTimesheetComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidthRatio = geometry.width / 1200.0;
        const geometryHeightRatio = geometry.height / 400.0;

        const smallHeight = 50 * geometryHeightRatio * dimentionsRatio;
        const bigHeight = 300 * geometryHeightRatio * dimentionsRatio;
        const width = 140 * geometryWidthRatio * dimentionsRatio;

        const descriptionPosX = geometry.drawPositionX + 50 * geometryWidthRatio * dimentionsRatio;
        const descriptionPosY = geometry.drawPositionY + 50 * geometryHeightRatio * dimentionsRatio;

        const firstElementPosY = geometry.drawPositionY + 50 * geometryHeightRatio * dimentionsRatio;
        const secondElementPosY = geometry.drawPositionY + 150 * geometryHeightRatio * dimentionsRatio;

        const componentSecundaryColor = "#EBF5FA";
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        const rowElements = [];
        let i;
        for (i = 0; i < 5; i++) {
            const rowPosX = geometry.drawPositionX + (250 + 190 * i) * geometryWidthRatio * dimentionsRatio;
            rowElements.push(
                <Group key={i}>
                    <Rect x={rowPosX}
                        y={firstElementPosY}
                        width={width}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Rect x={rowPosX}
                        y={secondElementPosY}
                        width={width}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>
            );
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Rect x={descriptionPosX}
                        y={descriptionPosY}
                        width={width}
                        height={bigHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>

                {rowElements}
            </Group>
        );
    }
}
